/*
 * Judge.me Reviews Grid: adds a "Collapse" button next to "Show more".
 * Judge.me only ships "Show more". After it's used, "Collapse" hides every card
 * past the first page and scrolls back to the grid. While collapsed, "Show more"
 * re-reveals the hidden cards instead of fetching a new page.
 * Relies on Judge.me classes: .jdgm-reviews-grid-widget, .jdgm-grid-body, .jdgm-review-card, .jm-show-more-button
 */
(function () {
  var state = new WeakMap(); // widget -> { pageSize, btn }

  function cards(widget, selector) {
    return Array.prototype.slice.call(widget.querySelectorAll('.jdgm-review-card' + (selector || '')));
  }

  function isCollapsed(widget) {
    return cards(widget, '[data-show-less-hidden]').length > 0;
  }

  // Sit beside Judge.me's button; once they drop it (all reviews loaded), sit under the grid.
  function render(widget, s, label) {
    var more = widget.querySelector('.jm-show-more-button');
    var collapsed = isCollapsed(widget);
    s.btn.querySelector('span').textContent = label;
    var svg = s.btn.querySelector('svg');
    if (svg) svg.style.transform = label === 'Collapse' ? 'rotate(180deg)' : '';

    if (collapsed && more) {
      s.btn.remove(); // Judge.me's "Show more" handles re-expanding
    } else if (more) {
      more.after(s.btn);
      s.btn.style.margin = '0 0 0 2rem';
    } else {
      widget.querySelector('.jdgm-grid-body').after(s.btn);
      s.btn.style.margin = '1.5rem auto 0';
    }
  }

  function collapse(widget, s) {
    cards(widget).slice(s.pageSize).forEach(function (card) {
      card.style.display = 'none';
      card.setAttribute('data-show-less-hidden', '');
    });
    render(widget, s, 'Show more');
    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function expand(widget, s) {
    cards(widget, '[data-show-less-hidden]').forEach(function (card) {
      card.style.display = '';
      card.removeAttribute('data-show-less-hidden');
    });
    render(widget, s, 'Collapse');
  }

  function setup(widget, moreBtn) {
    // Clone Judge.me's button so it keeps their scoped styling.
    var s = { pageSize: cards(widget).length, btn: moreBtn.cloneNode(true) };
    s.btn.disabled = false;
    s.btn.classList.add('jdgm-show-less-button');
    s.btn.addEventListener('click', function () {
      if (isCollapsed(widget)) expand(widget, s);
      else collapse(widget, s);
    });
    // Judge.me removes its button row (and ours with it) after the last page loads.
    new MutationObserver(function () {
      if (!s.btn.isConnected && !isCollapsed(widget)) render(widget, s, 'Collapse');
    }).observe(widget, { childList: true, subtree: true });
    state.set(widget, s);
    return s;
  }

  // Capture phase so a collapsed grid can re-expand without Judge.me loading another page.
  document.addEventListener('click', function (e) {
    var moreBtn = e.target.closest('.jdgm-reviews-grid-widget .jm-show-more-button:not(.jdgm-show-less-button)');
    if (!moreBtn) return;
    var widget = moreBtn.closest('.jdgm-reviews-grid-widget');
    var s = state.get(widget) || setup(widget, moreBtn);

    if (isCollapsed(widget)) {
      e.stopPropagation();
      e.preventDefault();
    }
    expand(widget, s);
  }, true);
})();
